/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SpoCreateNewModule} from './spo/spo-create-new/spo-create-new.module';
import {NgbCollapseModule, NgbDateParserFormatter, NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {SpoMainPageModule} from './spo/spo-main-page/spo-main-page.module';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {APIInterceptor} from './interceptors/api-interceptor/api.interceptor';
import {ClientErrorHandler} from './client-error.handler';
import {SpoDetailPageModule} from './spo/spo-detail-page/spo-detail-page.module';
import {SpoEditPageModule} from './spo/spo-edit-page/spo-edit-page.module';
import {SpoSharedModule} from './spo/shared/spo-shared.module';
import {StickyHeaderModule} from './shared/sticky-header/sticky-header.module';
import {BreadcrumbsModule} from './shared/breadcrumbs/breadcrumbs.module';
import {SideBarMenuModule} from './shared/side-bar-menu/side-bar-menu.module';
import {AuthorizationHeaderInterceptor} from './interceptors/authorization-header.interceptor';
import {LoadingSpinnerModule} from './shared/loading/loading-spinner/loading-spinner.module';
import {ErrorPageModule} from './shared/error-page/error-page-module';
import {WelcomePageModule} from './welcome-page/welcome-page.module';
import {AboutModule} from './about/about.module';
import {SettingsModule} from './settings/settings.module';
import {SpoModule} from './spo/spo.module';
import {ClaimModule} from './claim/claim.module';
import {PendingRequestsInterceptor} from './interceptors/peding-requests/pending-requests.interceptor';
import {DateCustomParserFormatter} from './shared/services/date-custom-parser-formatter/date-custom-parser-formatter.service';
import {PartNumberChangesModule} from './part-number-changes/part-number.changes.module';
import {SettlementsModule} from './settlements/settlements.module';
import {IS_TEST_ENVIRONMENT} from './shared/utils/is-test-environment';
import {BundlesModule} from './bundles/bundles.module';
import {CarouselModule} from './shared/carousel/carousel.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {TrainingMaterialsModule} from './training-materials/training-materials.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        SettingsModule,
        SpoModule,
        ClaimModule,
        BrowserModule,
        AppRoutingModule,
        SpoCreateNewModule,
        NgbDatepickerModule,
        ReactiveFormsModule,
        SpoSharedModule,
        SpoMainPageModule,
        SpoDetailPageModule,
        SpoEditPageModule,
        SideBarMenuModule,
        BrowserAnimationsModule,
        StickyHeaderModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            disableTimeOut: IS_TEST_ENVIRONMENT,
            enableHtml: true,
            tapToDismiss: false,
            closeButton: true
        }),
        NgbCollapseModule,
        BreadcrumbsModule,
        LoadingSpinnerModule,
        ErrorPageModule,
        WelcomePageModule,
        AboutModule,
        PartNumberChangesModule,
        SettlementsModule,
        BundlesModule,
        CarouselModule,
        DashboardModule,
        TrainingMaterialsModule
    ],
    providers: [
        {provide: ErrorHandler, useClass: ClientErrorHandler},
        {provide: HTTP_INTERCEPTORS, useClass: APIInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: AuthorizationHeaderInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: PendingRequestsInterceptor, multi: true},
        {provide: NgbDateParserFormatter, useClass: DateCustomParserFormatter}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
